import type {
  EventDocumentType,
  Paginated,
  PaginatedResponse,
  QueryArgs,
  Sortable,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { eventDocumentsQueryKeys } from "../query-keys/event-documents.query-keys";

export type FilterEventDocumentType = {
  searchText?: string;
};

export type PaginatedEventDocuments = Sortable<
  Paginated<FilterEventDocumentType>
>;

export type EventDocumentsResponse = PaginatedResponse<EventDocumentType>;

const getEventDocuments = async (
  eventId: string,
  structureId: string,
  params: PaginatedEventDocuments
) => {
  const res = await privateAxios.get<EventDocumentsResponse>(
    `/events/${eventId}/exhibitors/${structureId}/documents`,
    { params }
  );
  return res.data;
};

export const useGetEventDocumentsQuery = (
  eventId: string,
  structureId: string,
  params: PaginatedEventDocuments,
  options?: QueryArgs<EventDocumentsResponse>
) => {
  return useQuery({
    queryKey: [
      ...eventDocumentsQueryKeys.list(eventId, structureId),
      params,
    ] as const,
    queryFn: () => getEventDocuments(eventId, structureId, params),
    ...options,
  });
};
